"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { SITE_URL } from "@opensea/utils";
import { collectionUrlFragment, getCollectionUrl } from "@/components/collection/utils";
import { JsonLD } from "./JsonLD";
export const CollectionJsonLdFragment = graphql(`
    fragment CollectionJsonLd on Collection {
      name
      description
      imageUrl
      slug
      isVerified
      externalUrl
      twitterUsername
      instagramUsername
      discordUrl
      chain {
        identifier
      }
      address
      ...collectionUrl
    }
  `, [collectionUrlFragment]);
export function CollectionJsonLD(t0) {
  const $ = _c(27);
  const {
    collection: collectionKey
  } = t0;
  let T0;
  let collection;
  let sameAs;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== collectionKey) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      collection = readFragment(CollectionJsonLdFragment, collectionKey);
      if (!collection) {
        t8 = null;
        break bb0;
      }
      sameAs = [];
      if (collection.externalUrl) {
        sameAs.push(collection.externalUrl);
      }
      if (collection.twitterUsername) {
        sameAs.push(`https://twitter.com/${collection.twitterUsername}`);
      }
      if (collection.instagramUsername) {
        sameAs.push(`https://instagram.com/${collection.instagramUsername}`);
      }
      if (collection.discordUrl) {
        sameAs.push(collection.discordUrl);
      }
      T0 = JsonLD;
      t3 = "https://schema.org";
      t4 = "Brand";
      t5 = collection.name;
      t6 = collection.description || undefined;
      t7 = collection.imageUrl || undefined;
      t1 = SITE_URL.origin;
      t2 = getCollectionUrl(collection);
    }
    $[0] = collectionKey;
    $[1] = T0;
    $[2] = collection;
    $[3] = sameAs;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    T0 = $[1];
    collection = $[2];
    sameAs = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  const t9 = `${t1}${t2}`;
  const t10 = sameAs.length > 0 ? sameAs : undefined;
  const t11 = collection.slug || undefined;
  let t12;
  if ($[12] !== collection.isVerified) {
    t12 = collection.isVerified && {
      additionalProperty: {
        "@type": "PropertyValue",
        name: "verified",
        value: "true"
      }
    };
    $[12] = collection.isVerified;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t13 = {
      "@context": t3,
      "@type": t4,
      name: t5,
      description: t6,
      image: t7,
      url: t9,
      sameAs: t10,
      identifier: t11,
      ...t12
    };
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== T0 || $[25] !== t13) {
    t14 = <T0 data={t13} />;
    $[24] = T0;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}